<template>
  <div class="checkout-footer bottom-footer">
    <section class="row row--narrow footer-navigation" aria-labelledby="footer-support-links">
      <h2 id="footer-support-links" class="sr-only">{{ $t('text.help') }}</h2>
      <ul class="checkout-footer__navigation-holder">
        <slot name="navigation-nodes" />
      </ul>
    </section>
    <section
      class="flex flex-col md:flex-row justify-between items-start md:items-center flex-wrap md:bg-none py-4 mb-3 md:mb-5 mx-auto max-w-[75rem]"
      aria-labelledby="footer-legal-links"
    >
      <span
        id="footer-legal-links"
        class="inline-block text-sm text-gray-90 leading-tight lg:leading-snug font-body no-underline hover:text-red-100"
      >
        {{ notice }}
      </span>
      <nav class="ml-0 md:ml-auto" :aria-label="$t('aria.navigation.footer')">
        <slot name="footer-items" />
      </nav>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    notice: {
      type: String,
      required: true,
    },
    cdnStaticFilesRoot: {
      type: String,
      default: '',
    },
  },
};
</script>
